import React from 'react';
import classNames from 'classnames';
import styles from './index.module.scss';

// Нижні посилання з макета. Політика конфіденційності — окрема сторінка
// застосунку, решта відкривається як внутрішні екрани флоу.
const FooterLinks = ({ onTerms, onCookies, className }) => (
  <div className={classNames(styles.footerLinks, className)}>
    <a
      href="https://yourjourney.com.ua/personal-data-policy"
      target="_blank"
      rel="noopener noreferrer"
    >
      Політика конфіденційності
    </a>
    <button type="button" onClick={onTerms}>
      Умови використання
    </button>
    <button type="button" onClick={onCookies}>
      Параметри застосування файлів cookies
    </button>
  </div>
);

export default FooterLinks;
